<template>
  <button :class="btnCls"
          @click="onClick"
          :style="{ minWidth: btnMinWidth, height: btnHeight }">
    {{ props.config.buttonText }}
  </button>
</template>

<script setup>
  import { ref, computed } from 'vue'

  const props = defineProps({
    config: Object,
  })

  const emit = defineEmits(['click'])

  // if not provided, default to true
  const enabled = ref(props.config.defaultEnabled !== undefined ? props.config.defaultEnabled : true)
  const btnMinWidth = '115px'
  const btnHeight = props.config.height || '30' + 'px'
  const btnColor = computed(() => {
    const color = props.config.color || 'green'; // default 'green'
    return `btn-${color}`;
  });
  const onClick = (event) => {
    if (enabled.value) {
      emit('click', event)
    }
  }

  const setEnabled = (value) => {
    enabled.value = value
  }


  const btnCls = computed(() => {
    let cls = btnColor.value;

    if (enabled.value) {
      cls += ' enabled'
    } else {
      cls += ' disabled'
    }

    return cls
  })

  defineExpose({
    setEnabled,
  });

</script>

<style scoped>
button {
  flex-shrink: 0;
  border-radius: 15px;
  justify-content: center;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 0 30px;
}
.btn-green {
  color: #FFFFFF;
  border: 1px solid #09A0AD;
  background: #1EB9C7;
}

.btn-green.enabled {
  cursor: pointer;
  &:hover {
    border-color: #13ACBA;
    background-color: #2AC6D4;
  }
}

.btn-green.disabled {
  color: #8FDCE3;
  cursor: unset;
}

.btn-gray {
  color: #2E3032;
  border: 1px solid #D8DADC;
  background: #F6F8FA;
}

.btn-gray.enabled {
  cursor: pointer;
  &:hover {
    border-color: #C4C6C8;
  }
}

.btn-gray.disabled {
  color: #BABCBE;
  cursor: unset;
}
</style>

